import ListingHeader from "../../../components/listingHeader/listingHeader";
import SBEditable from "../../../components/sbEditable/sbEditable";
import RichTextWithBlokRenderer from "../../../components/richTextRenderer/richTextRenderer";
import styles from "./richTextPanel.module.scss";
import { SVGIconKeyToComponent } from "../../../helpers/datasourceHelpers";

/// Blok:richTextPanel
// richtextpanel:blok
///
/// header:string
/// header_underline_color:string
/// content:richtext
function RichTextPanel({ blok }) {
  return (
    <SBEditable blok={blok} withId={blok.anchor}>
      <div className={`richtext ${styles.root}`}>
        {blok.header || blok.header_icon ? (
          <ListingHeader underlineColor={blok.header_underline_color}>
            <h2>
              {blok.header}
              <span className={styles.icon}>
                {SVGIconKeyToComponent(blok.header_icon)}
              </span>
            </h2>
          </ListingHeader>
        ) : null}
        <div
          className={
            `${styles.richTextContainer}` +
            (blok.text_padding_right ? ` ${styles.paddingRight}` : "")
          }
        >
          <RichTextWithBlokRenderer document={blok.content} />
        </div>
      </div>
    </SBEditable>
  );
}

export default RichTextPanel;
